import { Navigate } from "react-router-dom";
import { landingPathFor } from "../../constants/roles";

// Routes users to their role-appropriate landing page. Waitlist staff land on
// the waitlist and operations staff on the orders list, since neither has
// dashboard access; everyone else lands on the dashboard.
function RoleHomeRedirect() {
  return <Navigate to={landingPathFor()} replace />;
}

export default RoleHomeRedirect;
